// extracted by mini-css-extract-plugin
export default {"container":"I1FNUjdVRLEffbzZrKK7","content":"upRIR61A4LKiSpWLxIBi","box":"Kmv0nlJGQJrSXZVrRn5o","alert":"xthstJlJdwjz0MzcSAYw","buttonContainer":"RA8tFOkfxTggLjwn_TGM"};